import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSpc } from '../context/SpcContext';
import { MessageCircle } from 'lucide-react';

export default function WhatsappJoinPopup() {
  const { user, state, markWhatsappPromptSeen } = useSpc();
  const [dismissed, setDismissed] = React.useState(false);
  const whatsappUrl = state?.settings?.whatsappUrl;

  const shouldShow = !!user && user.approvalStatus === 'approved' && !user.whatsappPromptSeen && !!whatsappUrl && !dismissed;

  const dismiss = () => { setDismissed(true); markWhatsappPromptSeen(); };
  const join = () => { window.open(whatsappUrl, '_blank', 'noopener'); dismiss(); };

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          className="welcome-backdrop"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          data-testid="whatsapp-join-popup"
        >
          <motion.div
            className="welcome-card"
            initial={{ scale: 0.85, opacity: 0, y: 30 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 220, damping: 22 }}
          >
            <div className="welcome-body">
              <div className="welcome-icon"><MessageCircle size={38} /></div>
              <h2 data-testid="whatsapp-join-title">Join our WhatsApp Clubhouse</h2>
              <p>
                Haven't joined yet? Jump into the SPC WhatsApp group to chat with the crew, get session updates
                and hear about socials first.
              </p>
            </div>
            <div className="welcome-actions">
              <button className="btn" onClick={join} data-testid="whatsapp-join-btn">Join WhatsApp</button>
              <button className="btn ghost" onClick={dismiss} data-testid="whatsapp-join-dismiss-btn">Maybe later</button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
